<app-validate-ticket *ngIf="stateView == 0" (on-continue)="onContinueValidateTicket($event)"></app-validate-ticket>
<app-customer-information *ngIf="stateView == 1" (on-continue)="onContinueCustomerInformation($event)"
    (on-return)="onReturnCustomerInformation()" [data]="addenda"></app-customer-information>
<app-confirm-invoice *ngIf="stateView == 2" (on-return)="onReturnBillingConfirmation()" [data]="finalRequestTicket"></app-confirm-invoice>
